import { Routes } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { SociosanitaryGuard } from "./_guards/sociosanitary.guard";
import { environment } from "src/environments/environment";
import { PublicRedirectionGuard } from "./_guards/public-redirection.guard";
import { FlowNavigationGuard } from "./_guards/flow-navigation.guard";
const ɵ0 = { title: "routeTitles.login" }, ɵ1 = () => import("./_modules/login/login.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ2 = { title: "routeTitles.recovery" }, ɵ3 = () => import("./_modules/recovery/recovery.module.ngfactory").then(m => m.RecoveryPageModuleNgFactory), ɵ4 = { title: "routeTitles.changePassword" }, ɵ5 = () => import("./_modules/changepassword/changepassword.module.ngfactory").then(m => m.ChangepasswordPageModuleNgFactory), ɵ6 = { title: "routeTitles.santanderPortugalAutologinToken" }, ɵ7 = () => import("./_modules/mock/auth-strategy/santander-portugal-autologin-token/santander-portugal-autologin-token.module.ngfactory").then(m => m.AutologinTokenPageModuleNgFactory), ɵ8 = { title: "routeTitles.about", type: "0" }, ɵ9 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ10 = { title: "routeTitles.beneficiaries", type: "1" }, ɵ11 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ12 = { title: "routeTitles.faq", type: "2" }, ɵ13 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ14 = { title: "routeTitles.id4", type: "3" }, ɵ15 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ16 = { title: "routeTitles.id5", type: "4" }, ɵ17 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ18 = { title: "routeTitles.serviceIndex" }, ɵ19 = () => import("./_modules/service-index/service-index.module.ngfactory").then(m => m.ServiceIndexPageModuleNgFactory), ɵ20 = { title: "routeTitles.serviceDetails" }, ɵ21 = () => import("./_modules/service-details/service-details.module.ngfactory").then(m => m.ServiceDetailsPageModuleNgFactory), ɵ22 = { title: "routeTitles.serviceAvailability" }, ɵ23 = () => import("./_modules/service-availability/service-availability.module.ngfactory").then(m => m.ServiceAvailabilityPageModuleNgFactory), ɵ24 = { title: "routeTitles.serviceRequest" }, ɵ25 = () => import("./_modules/service-request/service-request.module.ngfactory").then(m => m.ServiceRequestPageModuleNgFactory), ɵ26 = { title: "routeTitles.contact" }, ɵ27 = () => import("./_modules/contact/contact.module.ngfactory").then(m => m.ContactPageModuleNgFactory), ɵ28 = { title: "routeTitles.feature" }, ɵ29 = () => import("./_modules/feature/feature.module.ngfactory").then(m => m.FeaturePageModuleNgFactory), ɵ30 = { title: "routeTitles.sociosanitary" }, ɵ31 = () => import("./_modules/sociosanitary/sociosanitary.module.ngfactory").then(m => m.SociosanitaryPageModuleNgFactory), ɵ32 = { title: "routeTitles.personalArea" }, ɵ33 = () => import("./_modules/personal-area/personal-area-index/personal-area-index.module.ngfactory").then(m => m.PersonalAreaIndexPageModuleNgFactory), ɵ34 = { title: "routeTitles.personalAreaMyData" }, ɵ35 = () => import("./_modules/personal-area/user/user.module.ngfactory").then(m => m.UserPageModuleNgFactory), ɵ36 = { title: "routeTitles.personalAreaMyServices" }, ɵ37 = () => import("./_modules/personal-area/user-services/user-services.module.ngfactory").then(m => m.UserServicesPageModuleNgFactory), ɵ38 = { title: "routeTitles.personalAreaMyBeneficiaries" }, ɵ39 = () => import("./_modules/personal-area/beneficiary/beneficiary.module.ngfactory").then(m => m.BeneficiaryPageModuleNgFactory), ɵ40 = { title: "routeTitles.personalAreaRequestDetails" }, ɵ41 = () => import("./_modules/personal-area/request-details/request-details.module.ngfactory").then(m => m.RequestDetailsPageModuleNgFactory), ɵ42 = { title: "routeTitles.personalAreaStockDetails" }, ɵ43 = () => import("./_modules/personal-area/stock-details/stock-details.module.ngfactory").then(m => m.StockDetailsPageModuleNgFactory), ɵ44 = { title: "routeTitles.vipSearchAirport" }, ɵ45 = () => import("./_modules/dragonpass/search-airport/search-airport.module.ngfactory").then(m => m.SearchAirportPageModuleNgFactory), ɵ46 = { title: "routeTitles.vipTerminalDetails" }, ɵ47 = () => import("./_modules/dragonpass/terminal-details/terminal-details.module.ngfactory").then(m => m.TerminalDetailsPageModuleNgFactory), ɵ48 = { title: "routeTitles.vipResourceDetails" }, ɵ49 = () => import("./_modules/dragonpass/resource-details/resource-details.module.ngfactory").then(m => m.ResourceDetailsPageModuleNgFactory), ɵ50 = { title: "routeTitles.vipCheckAvailability" }, ɵ51 = () => import("./_modules/dragonpass/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ52 = { title: "routeTitles.vipForm" }, ɵ53 = () => import("./_modules/dragonpass/form/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ54 = { title: "Detalle de recurso" }, ɵ55 = () => import("./_modules/fast-track/form/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ56 = { title: "routeTitles.forceError" }, ɵ57 = () => import("./_modules/force-error/force-error.module.ngfactory").then(m => m.ForceErrorPageModuleNgFactory), ɵ58 = { title: "routeTitles.esimCheckAvailability" }, ɵ59 = () => import("./_modules/e-sim-flag/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ60 = { title: "routeTitles.esimForm" }, ɵ61 = () => import("./_modules/e-sim-flag/form/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ62 = { title: "routeTitles.transferCheckAvailability" }, ɵ63 = () => import("./_modules/transfer/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ64 = { title: "routeTitles.transferForm" }, ɵ65 = () => import("./_modules/transfer/form/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ66 = { title: "Formulario Transfer" }, ɵ67 = () => import("./_modules/uber/form/uber-form.module.ngfactory").then(m => m.UberFormPageModuleNgFactory), ɵ68 = { title: "routeTitles.serviceAvailability" }, ɵ69 = () => import("./_modules/handyman/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ70 = { title: "routeTitles.serviceRequest" }, ɵ71 = () => import("./_modules/handyman/form/form.module.ngfactory").then(m => m.FormPageModuleNgFactory);
const routes = [
    // Public routes
    {
        path: "",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    },
    {
        path: ":locale",
        data: ɵ0,
        loadChildren: ɵ1,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/recovery",
        data: ɵ2,
        loadChildren: ɵ3,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/change-password/:token",
        data: ɵ4,
        loadChildren: ɵ5,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/santander-portugal-autologin-token",
        data: ɵ6,
        loadChildren: ɵ7,
        canActivate: [PublicRedirectionGuard]
    },
    // Protected routes
    {
        path: ":locale/about",
        data: ɵ8,
        loadChildren: ɵ9,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/beneficiaries",
        data: ɵ10,
        loadChildren: ɵ11,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/faq",
        data: ɵ12,
        loadChildren: ɵ13,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-4",
        data: ɵ14,
        loadChildren: ɵ15,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-5",
        data: ɵ16,
        loadChildren: ɵ17,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-index",
        data: ɵ18,
        loadChildren: ɵ19,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-details/:id",
        data: ɵ20,
        loadChildren: ɵ21,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-availability/:id",
        data: ɵ22,
        loadChildren: ɵ23,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id",
        data: ɵ24,
        loadChildren: ɵ25,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/contact",
        data: ɵ26,
        loadChildren: ɵ27,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/feature/:id",
        data: ɵ28,
        loadChildren: ɵ29,
    },
    {
        path: ":locale/sociosanitary",
        data: ɵ30,
        loadChildren: ɵ31,
        canActivate: [SociosanitaryGuard, AuthGuard]
    },
    {
        path: ":locale/personal-area",
        data: ɵ32,
        loadChildren: ɵ33,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-data",
        data: ɵ34,
        loadChildren: ɵ35,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-services",
        data: ɵ36,
        loadChildren: ɵ37,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-beneficiaries",
        data: ɵ38,
        loadChildren: ɵ39,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/request-details/:id",
        data: ɵ40,
        loadChildren: ɵ41,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/stock-details/:publicUuid",
        data: ɵ42,
        loadChildren: ɵ43,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/search-airport",
        data: ɵ44,
        loadChildren: ɵ45,
        canActivate: [FlowNavigationGuard, AuthGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/terminal-details",
        data: ɵ46,
        loadChildren: ɵ47,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/resource-details",
        data: ɵ48,
        loadChildren: ɵ49,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/check-availability",
        data: ɵ50,
        loadChildren: ɵ51,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/form",
        data: ɵ52,
        loadChildren: ɵ53,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/fast-track/form",
        data: ɵ54,
        loadChildren: ɵ55,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/force-error",
        data: ɵ56,
        loadChildren: ɵ57,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id/esim-flag/check-availability",
        data: ɵ58,
        loadChildren: ɵ59,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/esim-flag/form",
        data: ɵ60,
        loadChildren: ɵ61,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/check-availability",
        data: ɵ62,
        loadChildren: ɵ63,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/form",
        data: ɵ64,
        loadChildren: ɵ65,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/uber-form",
        data: ɵ66,
        loadChildren: ɵ67,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/handyman/check-availability",
        data: ɵ68,
        loadChildren: ɵ69,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/handyman/form",
        data: ɵ70,
        loadChildren: ɵ71,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: "**",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40, ɵ41, ɵ42, ɵ43, ɵ44, ɵ45, ɵ46, ɵ47, ɵ48, ɵ49, ɵ50, ɵ51, ɵ52, ɵ53, ɵ54, ɵ55, ɵ56, ɵ57, ɵ58, ɵ59, ɵ60, ɵ61, ɵ62, ɵ63, ɵ64, ɵ65, ɵ66, ɵ67, ɵ68, ɵ69, ɵ70, ɵ71 };
